import { IUtilsService } from './IUtilsService';
import { LearningCoreRestCRUDService } from '../common/LearningCoreRestCRUDService';

export class RestUtilsService extends LearningCoreRestCRUDService<any> implements IUtilsService {
  getEndpoint(): string {
    return `${this.learningConfig.url.api.learning}/utils`;
  }

  async checkImageUrl(url: string): Promise<boolean> {
    const response = await this.request()
      .url(`${this.getEndpoint()}/check-image`)
      .post({ url })
      .json<{ isValid: boolean }>()
      .catch(this.handleError);

    return response?.isValid ?? false;
  }
}
